module.exports = __webpack_public_path__ + "img/gemerbarbier_homeBackground.48755c16.jpg";